var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { flex: "" } },
    [
      _c(
        "div",
        { staticClass: "u8-pt-10 u8-pl-10", attrs: { "flex-box": "0" } },
        [
          _c("i", {
            staticClass: "u8-theme-collapse-toggle",
            class: {
              "el-icon-s-fold": !_vm.collapse,
              "el-icon-s-unfold": _vm.collapse,
            },
            on: { click: _vm.toggleSidebar },
          }),
        ]
      ),
      _c("div", { attrs: { "flex-box": "1" } }, [
        _c(
          "div",
          {
            staticClass: "u8-header-right-wrapper",
            attrs: { flex: "main:right" },
          },
          [
            _c(
              "div",
              { staticClass: "u8-header-item-group" },
              _vm._l(_vm.rightMenuGroup, function (item, index) {
                return _c(
                  "span",
                  { key: index, staticClass: "u8-header-item" },
                  [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: item.desc,
                          placement: "bottom-start",
                          "hide-after": 1000,
                        },
                      },
                      [
                        _c("el-button", {
                          attrs: { icon: item.icon, circle: "", size: "mini" },
                          on: {
                            click: function ($event) {
                              return _vm.onRightMenuClicked(item)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              0
            ),
            _c(
              "div",
              [_c("el-divider", { attrs: { direction: "vertical" } })],
              1
            ),
            _c(
              "div",
              { staticClass: "u8-header-user-info" },
              [
                _c(
                  "el-popover",
                  {
                    ref: "extraSearchPanel",
                    attrs: {
                      width: 300,
                      "visible-arrow": false,
                      placement: "bottom-end",
                      "popper-class": "u8-header-user-panel",
                      trigger: "manual",
                    },
                    model: {
                      value: _vm.userPanelVisible,
                      callback: function ($$v) {
                        _vm.userPanelVisible = $$v
                      },
                      expression: "userPanelVisible",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        attrs: { slot: "reference" },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            _vm.userPanelVisible = !_vm.userPanelVisible
                          },
                        },
                        slot: "reference",
                      },
                      [
                        _c("span", { staticClass: "u8-clickable" }, [
                          _vm._v(_vm._s(_vm.info.name)),
                        ]),
                        _c("span", { staticClass: "u8-ml-10" }, [
                          _c("i", {
                            staticClass: "u8-clickable",
                            class: {
                              "el-icon-arrow-down": !_vm.userPanelVisible,
                              "el-icon-arrow-up": _vm.userPanelVisible,
                            },
                          }),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "click-outside",
                            rawName: "v-click-outside",
                            value: _vm.hideUserPanel,
                            expression: "hideUserPanel",
                          },
                        ],
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "u8-header-user-panel__header",
                            attrs: { flex: "" },
                          },
                          [
                            _c("div", { attrs: { "flex-box": "1" } }, [
                              _c("div", { staticClass: "user-label" }, [
                                _vm._v("当前用户："),
                                _c("span", { staticClass: "user-name" }, [
                                  _vm._v(_vm._s(_vm.info.name)),
                                ]),
                              ]),
                            ]),
                            _c("div", { attrs: { "flex-box": "0" } }, [
                              _c("div", { staticClass: "user-right-btns" }),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "u8-header-user-panel__body" },
                          [
                            _c(
                              "el-row",
                              [
                                _c("el-col", { attrs: { span: 11 } }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "change-pwd",
                                      on: { click: _vm.showPwdDialog },
                                    },
                                    [
                                      _c("span", [
                                        _c("i", {
                                          staticClass: "iconfont u8-password",
                                        }),
                                      ]),
                                      _c("span", [_vm._v("修改密码")]),
                                    ]
                                  ),
                                ]),
                                _c(
                                  "el-col",
                                  { attrs: { span: 2 } },
                                  [
                                    _c("el-divider", {
                                      staticStyle: { height: "100px" },
                                      attrs: { direction: "vertical" },
                                    }),
                                  ],
                                  1
                                ),
                                _c("el-col", { attrs: { span: 11 } }, [
                                  _vm.info &&
                                  _vm.info.email &&
                                  _vm.info.email.length > 0
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "bind-phone",
                                          on: { click: _vm.showBindDialog },
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("ellipsis")(
                                                  _vm.info.email
                                                )
                                              )
                                            ),
                                          ]),
                                          _c("span", [_vm._v("修改邮箱")]),
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass: "bind-phone",
                                          on: { click: _vm.showBindDialog },
                                        },
                                        [
                                          _c("span", [
                                            _c("i", {
                                              staticClass: "iconfont u8-pad",
                                            }),
                                          ]),
                                          _c("span", [_vm._v("绑定邮箱")]),
                                        ]
                                      ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "u8-header-user-panel__footer",
                            on: { click: _vm.logout },
                          },
                          [
                            _c("span", [
                              _c("i", { staticClass: "iconfont u8-exit" }),
                            ]),
                            _c("span", [_vm._v("退出当前账号")]),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改密码",
            visible: _vm.changePwdDialogVisible,
            width: "40%",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.changePwdDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "pwdForm",
              attrs: {
                model: _vm.pwdForm,
                rules: _vm.pwdRules,
                "label-width": "120px",
                size: "small",
                "label-position": "left",
              },
            },
            [
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: false,
                        expression: "false",
                      },
                    ],
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.pwdForm.id,
                      callback: function ($$v) {
                        _vm.$set(_vm.pwdForm, "id", $$v)
                      },
                      expression: "pwdForm.id",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "旧密码", prop: "oldPwd" } },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off", placeholder: "请输入旧密码" },
                    model: {
                      value: _vm.pwdForm.oldPwd,
                      callback: function ($$v) {
                        _vm.$set(_vm.pwdForm, "oldPwd", $$v)
                      },
                      expression: "pwdForm.oldPwd",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "新密码", prop: "newPwd" } },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off", placeholder: "请输入新密码" },
                    model: {
                      value: _vm.pwdForm.newPwd,
                      callback: function ($$v) {
                        _vm.$set(_vm.pwdForm, "newPwd", $$v)
                      },
                      expression: "pwdForm.newPwd",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.resetForm("pwdForm")
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.submitPwdForm()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "绑定邮箱",
            visible: _vm.bindDialogVisible,
            width: "40%",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.bindDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "bindForm",
              attrs: {
                model: _vm.bindForm,
                rules: _vm.bindRules,
                "label-width": "120px",
                size: "small",
                "label-position": "left",
              },
            },
            [
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: false,
                        expression: "false",
                      },
                    ],
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.bindForm.id,
                      callback: function ($$v) {
                        _vm.$set(_vm.bindForm, "id", $$v)
                      },
                      expression: "bindForm.id",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "邮 箱", prop: "email" } },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off", placeholder: "请输入邮箱" },
                    model: {
                      value: _vm.bindForm.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.bindForm, "email", $$v)
                      },
                      expression: "bindForm.email",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "验证码", prop: "code" } },
                [
                  _c(
                    "el-input",
                    {
                      attrs: {
                        autocomplete: "off",
                        placeholder: "请输入邮箱收到的验证码",
                      },
                      model: {
                        value: _vm.bindForm.code,
                        callback: function ($$v) {
                          _vm.$set(_vm.bindForm, "code", $$v)
                        },
                        expression: "bindForm.code",
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "append" },
                        [
                          _c("u8-sms-cd", {
                            attrs: { storeId: "userBindPhone" },
                            on: { click: _vm.sendBindEmail },
                          }),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.resetForm("bindForm")
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.submitBindForm()
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }